module.exports = __webpack_public_path__ + "static/media/events_active.89495b40.svg";